import {
  BSE_SAVE_META_INFO,
  BSE_ADD_TOOLS_TO_CART,
  BSE_RESET_DATA,
  BSE_SAVE_CLIENTS,
  LOGOUT,
  SET_CUSTOM_TOOL_TEMPLATES,
  SET_CUSTOM_TOOL_TYPE,
  SET_FILTER_CONCERNS,
} from "../Actions/types";

const INITIAL_STATE = {
  metaInfo: [],
  clients: [],
  addedTools: [],
  customTools: {
    templates: [],
    selectedToolType: null,
  },
  concerns: [],
};

const bseReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case BSE_SAVE_META_INFO:
      return { ...state, metaInfo: action.payload };
    case BSE_SAVE_CLIENTS:
      return { ...state, clients: action.payload };
    case BSE_ADD_TOOLS_TO_CART:
      return { ...state, addedTools: action.payload };
    case SET_CUSTOM_TOOL_TEMPLATES:
      return {
        ...state,
        customTools: { ...state.customTools, templates: action.payload },
      };
    case SET_CUSTOM_TOOL_TYPE:
      return {
        ...state,
        customTools: { ...state.customTools, selectedToolType: action.payload },
      };
    case SET_FILTER_CONCERNS:
      return { ...state, concerns: action.payload };
    case BSE_RESET_DATA:
    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default bseReducer;
